import { render, staticRenderFns } from "./SocietyContent.vue?vue&type=template&id=67f3d47d&scoped=true&"
import script from "./SocietyContent.vue?vue&type=script&lang=js&"
export * from "./SocietyContent.vue?vue&type=script&lang=js&"
import style0 from "./SocietyContent.vue?vue&type=style&index=0&id=67f3d47d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f3d47d",
  null
  
)

export default component.exports